import React from "react";
import cogoToast from "cogo-toast";
import { useState, useEffect } from "react";
import {
  createScoringPeriodApi,
  listScoringPeriodsApi,
  updateScoringPeriodApi,
  deleteScoringPeriodApi,
  getUsers,
  listDepartmentsApi,
} from "../../services/Api";
import { SUCCESS_RESULT } from "../../Constants";
import { FaTimes, FaEdit, FaPlus, FaTrash, FaSearch, FaInfoCircle, FaUser, FaBuilding } from "react-icons/fa";
import Select from "react-select";
import { useHistory } from "react-router-dom";
import {
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Button,
  Card,
  CardBody,
  CardHeader,
  Table,
  Input,
  Form,
  FormGroup,
  Label,
  Row,
  Col,
  Badge,
} from "reactstrap";
import BtnSpinner from "../../components/BtnSpinner";
import Swal from "sweetalert2";

const ScoringPeriods = (props) => {
  const history = useHistory();
  const [is_processing, setProcessing] = useState(false);
  const [periodsList, setPeriodsList] = useState([]);
  const [creatingPeriod, setCreatingPeriod] = useState(false);
  const [updatingPeriod, setUpdatingPeriod] = useState(false);
  const [formData, setFormData] = useState({
    name: "",
    description: "",
    status: 10001,
    reviewer_one: null,
    reviewer_two: null,
    scoring_panel: {},
  });
  const [usersList, setUsersList] = useState([]);
  const [departmentsList, setDepartmentsList] = useState([]);
  const [loadingUsers, setLoadingUsers] = useState(false);
  const [loadingDepartments, setLoadingDepartments] = useState(false);
  const [selectedUserForPanel, setSelectedUserForPanel] = useState(null);
  const [selectedDepartmentsForPanel, setSelectedDepartmentsForPanel] = useState([]);
  const [selectedUserForPanelUpdate, setSelectedUserForPanelUpdate] = useState(null);
  const [selectedDepartmentsForPanelUpdate, setSelectedDepartmentsForPanelUpdate] = useState([]);
  const [show_create_dialog, setShow_create_dialog] = useState(false);
  const [show_update_dialog, setShow_update_dialog] = useState(false);
  const [show_details_dialog, setShow_details_dialog] = useState(false);
  const [periodToUpdate, setPeriodToUpdate] = useState({});
  const [periodDetails, setPeriodDetails] = useState(null);
  const [searchTerm, setSearchTerm] = useState("");
  const [statusFilter, setStatusFilter] = useState("all"); // 10001 = Active, 10000 = Inactive, "all" = all

  useEffect(() => {
    fetch_periods_list();
    fetch_users();
    fetch_departments();
    return () => {};
  }, [statusFilter]);

  const fetch_users = () => {
    setLoadingUsers(true);
    getUsers()
      .then((res) => {
        setLoadingUsers(false);
        if (res.status === 200) {
          const response = res.data;
          if (response.status === SUCCESS_RESULT) {
            setUsersList(response.data || []);
          } else {
            cogoToast.error(response.message || "Failed to load users", { hideAfter: 5 });
            setUsersList([]);
          }
        } else {
          cogoToast.error(res.message || "Failed to load users", { hideAfter: 5 });
          setUsersList([]);
        }
      })
      .catch((e) => {
        setLoadingUsers(false);
        const errorMessage = e?.response?.data?.message || "Something went wrong, please try again.";
        cogoToast.error(errorMessage, { hideAfter: 5 });
        setUsersList([]);
      });
  };

  const fetch_departments = () => {
    setLoadingDepartments(true);
    listDepartmentsApi({})
      .then((res) => {
        setLoadingDepartments(false);
        if (res.status === 200) {
          const response = res.data;
          if (response.status === SUCCESS_RESULT) {
            setDepartmentsList(response.data || []);
          } else {
            cogoToast.error(response.message || "Failed to load departments", { hideAfter: 5 });
            setDepartmentsList([]);
          }
        } else {
          cogoToast.error(res.message || "Failed to load departments", { hideAfter: 5 });
          setDepartmentsList([]);
        }
      })
      .catch((e) => {
        setLoadingDepartments(false);
        const errorMessage = e?.response?.data?.message || "Something went wrong, please try again.";
        cogoToast.error(errorMessage, { hideAfter: 5 });
        setDepartmentsList([]);
      });
  };

  const fetch_periods_list = () => {
    setProcessing(true);

    const payload = statusFilter === "all" ? {} : { status: parseInt(statusFilter) };

    listScoringPeriodsApi(payload)
      .then((res) => {
        setProcessing(false);
        if (res.status === 200) {
          const response = res.data;
          if (response.status === SUCCESS_RESULT) {
            setPeriodsList(response.data || []);
          } else {
            cogoToast.error(response.message || "Failed to load periods", {
              hideAfter: 5,
            });
            setPeriodsList([]);
          }
        } else {
          cogoToast.error(res.message || "Failed to load periods", {
            hideAfter: 5,
          });
          setPeriodsList([]);
        }
      })
      .catch((e) => {
        setProcessing(false);
        const errorMessage =
          e?.response?.data?.message || "Something went wrong, please try again.";
        cogoToast.error(errorMessage, { hideAfter: 5 });
        setPeriodsList([]);
      });
  };

  const resetForm = () => {
    setFormData({
      name: "",
      description: "",
      status: 10001,
      reviewer_one: null,
      reviewer_two: null,
      scoring_panel: {},
    });
    setSelectedUserForPanel(null);
    setSelectedDepartmentsForPanel([]);
  };

  const addUserToPanel = () => {
    if (!selectedUserForPanel) {
      cogoToast.error("Please select a user", { hideAfter: 3 });
      return;
    }
    if (selectedDepartmentsForPanel.length === 0) {
      cogoToast.error("Please select at least one department", { hideAfter: 3 });
      return;
    }

    const userId = selectedUserForPanel.value;
    const departmentIds = selectedDepartmentsForPanel.map((dept) => dept.value);

    setFormData({
      ...formData,
      scoring_panel: {
        ...formData.scoring_panel,
        [userId]: departmentIds,
      },
    });

    setSelectedUserForPanel(null);
    setSelectedDepartmentsForPanel([]);
    cogoToast.success("User added to scoring panel", { hideAfter: 2 });
  };

  const removeUserFromPanel = (userId) => {
    const newPanel = { ...formData.scoring_panel };
    delete newPanel[userId];
    setFormData({
      ...formData,
      scoring_panel: newPanel,
    });
    cogoToast.success("User removed from scoring panel", { hideAfter: 2 });
  };

  const addUserToPanelUpdate = () => {
    if (!selectedUserForPanelUpdate) {
      cogoToast.error("Please select a user", { hideAfter: 3 });
      return;
    }
    if (selectedDepartmentsForPanelUpdate.length === 0) {
      cogoToast.error("Please select at least one department", { hideAfter: 3 });
      return;
    }

    const userId = selectedUserForPanelUpdate.value;
    const departmentIds = selectedDepartmentsForPanelUpdate.map((dept) => dept.value);

    setPeriodToUpdate({
      ...periodToUpdate,
      scoring_panel: {
        ...(periodToUpdate.scoring_panel || {}),
        [userId]: departmentIds,
      },
    });

    setSelectedUserForPanelUpdate(null);
    setSelectedDepartmentsForPanelUpdate([]);
    cogoToast.success("User added to scoring panel", { hideAfter: 2 });
  };

  const removeUserFromPanelUpdate = (userId) => {
    const newPanel = { ...(periodToUpdate.scoring_panel || {}) };
    delete newPanel[userId];
    setPeriodToUpdate({
      ...periodToUpdate,
      scoring_panel: newPanel,
    });
    cogoToast.success("User removed from scoring panel", { hideAfter: 2 });
  };

  const create_period = (e) => {
    e.preventDefault();

    if (!formData.name || formData.name.trim() === "") {
      cogoToast.error("Period name is required", { hideAfter: 3 });
      return;
    }

    setCreatingPeriod(true);

    let data = {
      name: formData.name.trim(),
      description: formData.description ? formData.description.trim() : "",
      status: parseInt(formData.status),
    };

    // Add reviewer_one if selected
    if (formData.reviewer_one) {
      data.reviewer_one = formData.reviewer_one.value;
    }

    // Add reviewer_two if selected
    if (formData.reviewer_two) {
      data.reviewer_two = formData.reviewer_two.value;
    }

    // Add scoring_panel if it has entries
    if (Object.keys(formData.scoring_panel).length > 0) {
      // Convert numeric keys to strings as required by API
      const scoringPanel = {};
      Object.keys(formData.scoring_panel).forEach((userId) => {
        scoringPanel[String(userId)] = formData.scoring_panel[userId];
      });
      data.scoring_panel = scoringPanel;
    }

    createScoringPeriodApi(data)
      .then((res) => {
        setCreatingPeriod(false);
        if (res.status === 200) {
          const response = res.data;
          if (response.status === SUCCESS_RESULT) {
            setShow_create_dialog(false);
            resetForm();
            fetch_periods_list();
            cogoToast.success(response.message || "Period created successfully", {
              hideAfter: 3,
            });
          } else {
            cogoToast.error(response.message || "Failed to create period", {
              hideAfter: 5,
            });
          }
        } else {
          cogoToast.error(res.message || "Failed to create period", {
            hideAfter: 5,
          });
        }
      })
      .catch((e) => {
        setCreatingPeriod(false);
        const errorMessage =
          e?.response?.data?.message || "Something went wrong, please try again.";
        cogoToast.error(errorMessage, { hideAfter: 5 });
      });
  };

  const update_period = (e) => {
    e.preventDefault();

    if (!periodToUpdate.id) {
      cogoToast.error("Period ID is missing", { hideAfter: 3 });
      return;
    }

    if (!periodToUpdate.name || periodToUpdate.name.trim() === "") {
      cogoToast.error("Period name is required", { hideAfter: 3 });
      return;
    }

    setUpdatingPeriod(true);

    let data = {
      id: periodToUpdate.id,
      name: periodToUpdate.name.trim(),
      description: periodToUpdate.description ? periodToUpdate.description.trim() : "",
      status: parseInt(periodToUpdate.status),
    };

    // Add reviewer_one if selected
    if (periodToUpdate.reviewer_one) {
      data.reviewer_one = periodToUpdate.reviewer_one.value;
    }

    // Add reviewer_two if selected
    if (periodToUpdate.reviewer_two) {
      data.reviewer_two = periodToUpdate.reviewer_two.value;
    }

    // Add scoring_panel if it has entries
    if (periodToUpdate.scoring_panel && Object.keys(periodToUpdate.scoring_panel).length > 0) {
      // Convert numeric keys to strings as required by API
      const scoringPanel = {};
      Object.keys(periodToUpdate.scoring_panel).forEach((userId) => {
        scoringPanel[String(userId)] = periodToUpdate.scoring_panel[userId];
      });
      data.scoring_panel = scoringPanel;
    }

    updateScoringPeriodApi(data)
      .then((res) => {
        setUpdatingPeriod(false);
        if (res.status === 200) {
          const response = res.data;
          if (response.status === SUCCESS_RESULT) {
            setShow_update_dialog(false);
            setPeriodToUpdate({});
            fetch_periods_list();
            cogoToast.success(response.message || "Period updated successfully", {
              hideAfter: 3,
            });
          } else {
            cogoToast.error(response.message || "Failed to update period", {
              hideAfter: 5,
            });
          }
        } else {
          cogoToast.error(res.message || "Failed to update period", {
            hideAfter: 5,
          });
        }
      })
      .catch((e) => {
        setUpdatingPeriod(false);
        const errorMessage =
          e?.response?.data?.message || "Something went wrong, please try again.";
        cogoToast.error(errorMessage, { hideAfter: 5 });
      });
  };

  const delete_period = (period) => {
    Swal.fire({
      title: "Delete Scoring Period?",
      text: `Are you sure you want to delete "${period.name}"? This action cannot be undone.`,
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#d33",
      cancelButtonColor: "#3085d6",
      confirmButtonText: "Yes, delete it",
      cancelButtonText: "Cancel",
    }).then((result) => {
      if (result.isConfirmed) {
        deleteScoringPeriodApi({ id: period.id })
          .then((res) => {
            if (res.status === 200) {
              const response = res.data;
              if (response.status === SUCCESS_RESULT) {
                fetch_periods_list();
                cogoToast.success(response.message || "Period deleted successfully", {
                  hideAfter: 3,
                });
              } else {
                cogoToast.error(response.message || "Failed to delete period", {
                  hideAfter: 5,
                });
              }
            } else {
              cogoToast.error(res.message || "Failed to delete period", {
                hideAfter: 5,
              });
            }
          })
          .catch((e) => {
            const errorMessage =
              e?.response?.data?.message || "Something went wrong, please try again.";
            cogoToast.error(errorMessage, { hideAfter: 5 });
          });
      }
    });
  };

  const view_details = (period) => {
    setPeriodDetails(period);
    setShow_details_dialog(true);
  };

  const filteredPeriods = periodsList.filter((period) => {
    if (!searchTerm) return true;
    const searchLower = searchTerm.toLowerCase();
    return (
      period.name?.toLowerCase().includes(searchLower) ||
      period.description?.toLowerCase().includes(searchLower) ||
      period.country?.name?.toLowerCase().includes(searchLower)
    );
  });

  const formatDate = (dateString) => {
    if (!dateString) return "N/A";
    try {
      const date = new Date(dateString);
      return date.toLocaleDateString("en-US", {
        year: "numeric",
        month: "short",
        day: "numeric",
        hour: "2-digit",
        minute: "2-digit",
      });
    } catch (e) {
      return dateString;
    }
  };

  return (
    <div style={{ padding: "20px" }}>
      <div className="page-header d-print-none mb-4">
        <div className="container-xl">
          <div className="row g-2 align-items-center">
            <div className="col">
              <h2 className="page-title">Scoring Periods</h2>
              <div className="text-muted mt-1">
                Manage scoring periods for staff evaluations
              </div>
            </div>
            <div className="col-auto ms-auto">
              <Button
                color="primary"
                onClick={() => {
                  resetForm();
                  setShow_create_dialog(true);
                }}
                style={{
                  background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
                  border: "none",
                  borderRadius: "8px",
                  fontWeight: "600",
                }}
              >
                <FaPlus style={{ marginRight: "8px" }} />
                Create Period
              </Button>
            </div>
          </div>
        </div>
      </div>

      <div className="container-xl">
        <Card className="shadow-sm">
          <CardHeader>
            <Row>
              <Col md={6}>
                <Label for="search">Search</Label>
                <div className="input-group">
                  <span className="input-group-text">
                    <FaSearch />
                  </span>
                  <Input
                    type="text"
                    id="search"
                    placeholder="Search periods..."
                    value={searchTerm}
                    onChange={(e) => setSearchTerm(e.target.value)}
                  />
                </div>
              </Col>
              <Col md={3}>
                <Label for="status_filter">Status</Label>
                <Input
                  type="select"
                  id="status_filter"
                  value={statusFilter}
                  onChange={(e) =>
                    setStatusFilter(
                      e.target.value === "all" ? "all" : parseInt(e.target.value)
                    )
                  }
                >
                  <option value="all">All Periods</option>
                  <option value={10001}>Active Only</option>
                  <option value={10000}>Inactive Only</option>
                </Input>
              </Col>
              <Col md={3} className="text-end">
                <Label>&nbsp;</Label>
                <div>
                  <Button
                    color="secondary"
                    outline
                    onClick={fetch_periods_list}
                    disabled={is_processing}
                  >
                    {is_processing ? "Loading..." : "Refresh"}
                  </Button>
                </div>
              </Col>
            </Row>
          </CardHeader>
          <CardBody>
            {is_processing && filteredPeriods.length === 0 ? (
              <div className="text-center py-5">
                <BtnSpinner loading={true} />
                <p className="mt-3 text-muted">Loading periods...</p>
              </div>
            ) : filteredPeriods.length === 0 ? (
              <div className="text-center py-5">
                <p className="text-muted">
                  {searchTerm ? "No periods found matching your search" : "No periods found"}
                </p>
              </div>
            ) : (
              <div className="table-responsive">
                <Table hover striped bordered>
                  <thead>
                    <tr>
                      <th>#</th>
                      <th>Name</th>
                      <th>Description</th>
                      <th>Country</th>
                      <th>Status</th>
                      <th>Reviewer One</th>
                      <th>Reviewer Two</th>
                      <th>Created By</th>
                      <th>Created At</th>
                      <th>Updated At</th>
                      <th>Actions</th>
                    </tr>
                  </thead>
                  <tbody>
                    {filteredPeriods.map((period, index) => (
                      <tr key={period.id}>
                        <td>{index + 1}</td>
                        <td>
                          <strong>{period.name}</strong>
                        </td>
                        <td>{period.description || "N/A"}</td>
                        <td>{period.country?.name || "N/A"}</td>
                        <td>
                          <Badge color={period.status === 10001 ? "success" : "secondary"}>
                            {period.status === 10001 ? "Active" : "Inactive"}
                          </Badge>
                        </td>
                        <td>
                          {period.reviewer_one_name || period.reviewer_one_user?.name || "N/A"}
                        </td>
                        <td>
                          {period.reviewer_two_name || period.reviewer_two_user?.name || "N/A"}
                        </td>
                        <td>
                          {period.created_by_user?.name || "N/A"}
                        </td>
                        <td>{formatDate(period.created_at)}</td>
                        <td>{formatDate(period.updated_at)}</td>
                        <td>
                          <div style={{ display: "flex", gap: "8px" }}>
                            <Button
                              color="info"
                              size="sm"
                              onClick={() => view_details(period)}
                              title="View Details"
                            >
                              <FaInfoCircle />
                            </Button>
                            <Button
                              color="primary"
                              size="sm"
                              onClick={() => {
                                // Use reviewer_one_user and reviewer_two_user from API response if available
                                // Otherwise fallback to searching in usersList
                                let reviewerOneUser = null;
                                let reviewerTwoUser = null;

                                if (period.reviewer_one_user) {
                                  reviewerOneUser = period.reviewer_one_user;
                                } else if (period.reviewer_one) {
                                  reviewerOneUser = usersList.find((u) => u.id === period.reviewer_one);
                                }

                                if (period.reviewer_two_user) {
                                  reviewerTwoUser = period.reviewer_two_user;
                                } else if (period.reviewer_two) {
                                  reviewerTwoUser = usersList.find((u) => u.id === period.reviewer_two);
                                }

                                // Load existing scoring_panel if available
                                let scoringPanel = {};
                                if (period.scoring_panel && typeof period.scoring_panel === 'object') {
                                  // Convert the scoring_panel object to the format we use
                                  Object.keys(period.scoring_panel).forEach((userId) => {
                                    scoringPanel[userId] = period.scoring_panel[userId];
                                  });
                                }

                                setPeriodToUpdate({
                                  id: period.id,
                                  name: period.name,
                                  description: period.description || "",
                                  status: period.status,
                                  reviewer_one: reviewerOneUser
                                    ? { value: reviewerOneUser.id, label: `${reviewerOneUser.name} (${reviewerOneUser.email})` }
                                    : null,
                                  reviewer_two: reviewerTwoUser
                                    ? { value: reviewerTwoUser.id, label: `${reviewerTwoUser.name} (${reviewerTwoUser.email})` }
                                    : null,
                                  scoring_panel: scoringPanel,
                                });
                                setSelectedUserForPanelUpdate(null);
                                setSelectedDepartmentsForPanelUpdate([]);
                                setShow_update_dialog(true);
                              }}
                              title="Edit"
                            >
                              <FaEdit />
                            </Button>
                            <Button
                              color="danger"
                              size="sm"
                              onClick={() => delete_period(period)}
                              title="Delete"
                            >
                              <FaTrash />
                            </Button>
                          </div>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </Table>
              </div>
            )}
          </CardBody>
        </Card>
      </div>

      {/* Create Period Modal */}
      <Modal
        isOpen={show_create_dialog}
        toggle={() => {
          setShow_create_dialog(false);
          resetForm();
        }}
        size="xl"
      >
        <ModalHeader toggle={() => {
          setShow_create_dialog(false);
          resetForm();
        }}>
          Create Scoring Period
        </ModalHeader>
        <Form onSubmit={create_period}>
          <ModalBody>
            <FormGroup>
              <Label for="name">
                Period Name <span className="text-danger">*</span>
              </Label>
              <Input
                type="text"
                id="name"
                value={formData.name}
                onChange={(e) => setFormData({ ...formData, name: e.target.value })}
                placeholder="e.g., Q1 2026 Performance Review"
                required
              />
            </FormGroup>
            <FormGroup>
              <Label for="description">Description</Label>
              <Input
                type="textarea"
                id="description"
                value={formData.description}
                onChange={(e) => setFormData({ ...formData, description: e.target.value })}
                rows="3"
                placeholder="Enter period description..."
              />
            </FormGroup>
            <FormGroup>
              <Label for="status">Status</Label>
              <Input
                type="select"
                id="status"
                value={formData.status}
                onChange={(e) =>
                  setFormData({ ...formData, status: parseInt(e.target.value) })
                }
              >
                <option value={10001}>Active</option>
                <option value={10000}>Inactive</option>
              </Input>
            </FormGroup>

            <hr />

            <h6 className="mb-3">
              <FaUser className="me-2" />
              Reviewers
            </h6>

            <Row>
              <Col md={6}>
                <FormGroup>
                  <Label for="reviewer_one">Reviewer One</Label>
                  <Select
                    id="reviewer_one"
                    value={formData.reviewer_one}
                    onChange={(selected) =>
                      setFormData({ ...formData, reviewer_one: selected })
                    }
                    options={usersList.map((user) => ({
                      value: user.id,
                      label: `${user.name} (${user.email})`,
                    }))}
                    placeholder="Select reviewer one..."
                    isSearchable
                    isClearable
                    isLoading={loadingUsers}
                  />
                </FormGroup>
              </Col>
              <Col md={6}>
                <FormGroup>
                  <Label for="reviewer_two">Reviewer Two</Label>
                  <Select
                    id="reviewer_two"
                    value={formData.reviewer_two}
                    onChange={(selected) =>
                      setFormData({ ...formData, reviewer_two: selected })
                    }
                    options={usersList.map((user) => ({
                      value: user.id,
                      label: `${user.name} (${user.email})`,
                    }))}
                    placeholder="Select reviewer two..."
                    isSearchable
                    isClearable
                    isLoading={loadingUsers}
                  />
                </FormGroup>
              </Col>
            </Row>

            <hr />

            <h6 className="mb-3">
              <FaBuilding className="me-2" />
              Scoring Panel (Assign Users to Departments)
            </h6>

            <Row className="mb-3">
              <Col md={5}>
                <FormGroup>
                  <Label for="panel_user">Select User</Label>
                  <Select
                    id="panel_user"
                    value={selectedUserForPanel}
                    onChange={(selected) => setSelectedUserForPanel(selected)}
                    options={usersList
                      .filter((user) => !formData.scoring_panel[user.id])
                      .map((user) => ({
                        value: user.id,
                        label: `${user.name} (${user.email})`,
                      }))}
                    placeholder="Select user..."
                    isSearchable
                    isClearable
                    isLoading={loadingUsers}
                  />
                </FormGroup>
              </Col>
              <Col md={5}>
                <FormGroup>
                  <Label for="panel_departments">Select Departments</Label>
                  <Select
                    id="panel_departments"
                    value={selectedDepartmentsForPanel}
                    onChange={(selected) => setSelectedDepartmentsForPanel(selected || [])}
                    options={departmentsList.map((dept) => ({
                      value: dept.id,
                      label: dept.department_name,
                    }))}
                    placeholder="Select departments..."
                    isSearchable
                    isMulti
                    isLoading={loadingDepartments}
                  />
                </FormGroup>
              </Col>
              <Col md={2} className="d-flex align-items-end">
                <Button
                  color="primary"
                  onClick={addUserToPanel}
                  disabled={!selectedUserForPanel || selectedDepartmentsForPanel.length === 0}
                  style={{ width: "100%" }}
                >
                  <FaPlus /> Add
                </Button>
              </Col>
            </Row>

            {Object.keys(formData.scoring_panel).length > 0 && (
              <div className="mt-3">
                <Label className="mb-2">Assigned Users & Departments:</Label>
                <div className="table-responsive">
                  <Table bordered size="sm">
                    <thead>
                      <tr>
                        <th>User</th>
                        <th>Departments</th>
                        <th>Actions</th>
                      </tr>
                    </thead>
                    <tbody>
                      {Object.keys(formData.scoring_panel).map((userId) => {
                        const user = usersList.find((u) => u.id === parseInt(userId));
                        const departmentIds = formData.scoring_panel[userId];
                        const departments = departmentIds
                          .map((deptId) => departmentsList.find((d) => d.id === deptId))
                          .filter(Boolean);

                        return (
                          <tr key={userId}>
                            <td>
                              {user ? `${user.name} (${user.email})` : `User ID: ${userId}`}
                            </td>
                            <td>
                              {departments.length > 0 ? (
                                <div className="d-flex flex-wrap gap-1">
                                  {departments.map((dept) => (
                                    <Badge key={dept.id} color="info">
                                      {dept.department_name}
                                    </Badge>
                                  ))}
                                </div>
                              ) : (
                                <span className="text-muted">No departments</span>
                              )}
                            </td>
                            <td>
                              <Button
                                color="danger"
                                size="sm"
                                onClick={() => removeUserFromPanel(userId)}
                              >
                                <FaTrash />
                              </Button>
                            </td>
                          </tr>
                        );
                      })}
                    </tbody>
                  </Table>
                </div>
              </div>
            )}
          </ModalBody>
          <ModalFooter>
            <Button
              color="secondary"
              onClick={() => {
                setShow_create_dialog(false);
                resetForm();
              }}
            >
              Cancel
            </Button>
            <Button color="primary" type="submit" disabled={creatingPeriod}>
              {creatingPeriod ? <BtnSpinner loading={true} /> : "Create"}
            </Button>
          </ModalFooter>
        </Form>
      </Modal>

      {/* Update Period Modal */}
      <Modal
        isOpen={show_update_dialog}
        toggle={() => {
          setShow_update_dialog(false);
          setPeriodToUpdate({});
        }}
        size="xl"
      >
        <ModalHeader toggle={() => {
          setShow_update_dialog(false);
          setPeriodToUpdate({});
        }}>
          Update Scoring Period
        </ModalHeader>
        <Form onSubmit={update_period}>
          <ModalBody>
            <FormGroup>
              <Label for="update_name">
                Period Name <span className="text-danger">*</span>
              </Label>
              <Input
                type="text"
                id="update_name"
                value={periodToUpdate.name || ""}
                onChange={(e) =>
                  setPeriodToUpdate({ ...periodToUpdate, name: e.target.value })
                }
                required
              />
            </FormGroup>
            <FormGroup>
              <Label for="update_description">Description</Label>
              <Input
                type="textarea"
                id="update_description"
                value={periodToUpdate.description || ""}
                onChange={(e) =>
                  setPeriodToUpdate({ ...periodToUpdate, description: e.target.value })
                }
                rows="3"
              />
            </FormGroup>
            <FormGroup>
              <Label for="update_status">Status</Label>
              <Input
                type="select"
                id="update_status"
                value={periodToUpdate.status || 10001}
                onChange={(e) =>
                  setPeriodToUpdate({ ...periodToUpdate, status: parseInt(e.target.value) })
                }
              >
                <option value={10001}>Active</option>
                <option value={10000}>Inactive</option>
              </Input>
            </FormGroup>

            <hr />

            <h6 className="mb-3">
              <FaUser className="me-2" />
              Reviewers
            </h6>

            <Row>
              <Col md={6}>
                <FormGroup>
                  <Label for="update_reviewer_one">Reviewer One</Label>
                  <Select
                    id="update_reviewer_one"
                    value={periodToUpdate.reviewer_one}
                    onChange={(selected) =>
                      setPeriodToUpdate({ ...periodToUpdate, reviewer_one: selected })
                    }
                    options={usersList.map((user) => ({
                      value: user.id,
                      label: `${user.name} (${user.email})`,
                    }))}
                    placeholder="Select reviewer one..."
                    isSearchable
                    isClearable
                    isLoading={loadingUsers}
                  />
                </FormGroup>
              </Col>
              <Col md={6}>
                <FormGroup>
                  <Label for="update_reviewer_two">Reviewer Two</Label>
                  <Select
                    id="update_reviewer_two"
                    value={periodToUpdate.reviewer_two}
                    onChange={(selected) =>
                      setPeriodToUpdate({ ...periodToUpdate, reviewer_two: selected })
                    }
                    options={usersList.map((user) => ({
                      value: user.id,
                      label: `${user.name} (${user.email})`,
                    }))}
                    placeholder="Select reviewer two..."
                    isSearchable
                    isClearable
                    isLoading={loadingUsers}
                  />
                </FormGroup>
              </Col>
            </Row>

            <hr />

            <h6 className="mb-3">
              <FaBuilding className="me-2" />
              Scoring Panel (Assign Users to Departments)
            </h6>

            <Row className="mb-3">
              <Col md={5}>
                <FormGroup>
                  <Label for="panel_user_update">Select User</Label>
                  <Select
                    id="panel_user_update"
                    value={selectedUserForPanelUpdate}
                    onChange={(selected) => setSelectedUserForPanelUpdate(selected)}
                    options={usersList
                      .filter((user) => !periodToUpdate.scoring_panel || !periodToUpdate.scoring_panel[user.id])
                      .map((user) => ({
                        value: user.id,
                        label: `${user.name} (${user.email})`,
                      }))}
                    placeholder="Select user..."
                    isSearchable
                    isClearable
                    isLoading={loadingUsers}
                  />
                </FormGroup>
              </Col>
              <Col md={5}>
                <FormGroup>
                  <Label for="panel_departments_update">Select Departments</Label>
                  <Select
                    id="panel_departments_update"
                    value={selectedDepartmentsForPanelUpdate}
                    onChange={(selected) => setSelectedDepartmentsForPanelUpdate(selected || [])}
                    options={departmentsList.map((dept) => ({
                      value: dept.id,
                      label: dept.department_name,
                    }))}
                    placeholder="Select departments..."
                    isSearchable
                    isMulti
                    isLoading={loadingDepartments}
                  />
                </FormGroup>
              </Col>
              <Col md={2} className="d-flex align-items-end">
                <Button
                  color="primary"
                  onClick={addUserToPanelUpdate}
                  disabled={!selectedUserForPanelUpdate || selectedDepartmentsForPanelUpdate.length === 0}
                  style={{ width: "100%" }}
                >
                  <FaPlus /> Add
                </Button>
              </Col>
            </Row>

            {periodToUpdate.scoring_panel && Object.keys(periodToUpdate.scoring_panel).length > 0 && (
              <div className="mt-3">
                <Label className="mb-2">Assigned Users & Departments:</Label>
                <div className="table-responsive">
                  <Table bordered size="sm">
                    <thead>
                      <tr>
                        <th>User</th>
                        <th>Departments</th>
                        <th>Actions</th>
                      </tr>
                    </thead>
                    <tbody>
                      {Object.keys(periodToUpdate.scoring_panel).map((userId) => {
                        const user = usersList.find((u) => u.id === parseInt(userId));
                        const departmentIds = periodToUpdate.scoring_panel[userId];
                        const departments = departmentIds
                          .map((deptId) => departmentsList.find((d) => d.id === deptId))
                          .filter(Boolean);

                        return (
                          <tr key={userId}>
                            <td>
                              {user ? `${user.name} (${user.email})` : `User ID: ${userId}`}
                            </td>
                            <td>
                              {departments.length > 0 ? (
                                <div className="d-flex flex-wrap gap-1">
                                  {departments.map((dept) => (
                                    <Badge key={dept.id} color="info">
                                      {dept.department_name}
                                    </Badge>
                                  ))}
                                </div>
                              ) : (
                                <span className="text-muted">No departments</span>
                              )}
                            </td>
                            <td>
                              <Button
                                color="danger"
                                size="sm"
                                onClick={() => removeUserFromPanelUpdate(userId)}
                              >
                                <FaTrash />
                              </Button>
                            </td>
                          </tr>
                        );
                      })}
                    </tbody>
                  </Table>
                </div>
              </div>
            )}
          </ModalBody>
          <ModalFooter>
            <Button
              color="secondary"
              onClick={() => {
                setShow_update_dialog(false);
                setPeriodToUpdate({});
                setSelectedUserForPanelUpdate(null);
                setSelectedDepartmentsForPanelUpdate([]);
              }}
            >
              Cancel
            </Button>
            <Button color="primary" type="submit" disabled={updatingPeriod}>
              {updatingPeriod ? <BtnSpinner loading={true} /> : "Update"}
            </Button>
          </ModalFooter>
        </Form>
      </Modal>

      {/* Details Modal */}
      <Modal
        isOpen={show_details_dialog}
        toggle={() => {
          setShow_details_dialog(false);
          setPeriodDetails(null);
        }}
        size="lg"
      >
        <ModalHeader toggle={() => {
          setShow_details_dialog(false);
          setPeriodDetails(null);
        }}>
          Period Details
        </ModalHeader>
        <ModalBody>
          {periodDetails && (
            <div>
              <Row className="mb-3">
                <Col md={6}>
                  <strong>Name:</strong>
                  <p>{periodDetails.name}</p>
                </Col>
                <Col md={6}>
                  <strong>Status:</strong>
                  <p>
                    <Badge color={periodDetails.status === 10001 ? "success" : "secondary"}>
                      {periodDetails.status === 10001 ? "Active" : "Inactive"}
                    </Badge>
                  </p>
                </Col>
              </Row>
              <Row className="mb-3">
                <Col md={12}>
                  <strong>Description:</strong>
                  <p>{periodDetails.description || "N/A"}</p>
                </Col>
              </Row>
              <Row className="mb-3">
                <Col md={6}>
                  <strong>Country:</strong>
                  <p>{periodDetails.country?.name || "N/A"}</p>
                </Col>
                <Col md={6}>
                  <strong>Created By:</strong>
                  <p>{periodDetails.created_by_user?.name || "N/A"}</p>
                </Col>
              </Row>
              <Row className="mb-3">
                <Col md={6}>
                  <strong>Created At:</strong>
                  <p>{formatDate(periodDetails.created_at)}</p>
                </Col>
                <Col md={6}>
                  <strong>Updated At:</strong>
                  <p>{formatDate(periodDetails.updated_at)}</p>
                </Col>
              </Row>
            </div>
          )}
        </ModalBody>
        <ModalFooter>
          <Button
            color="secondary"
            onClick={() => {
              setShow_details_dialog(false);
              setPeriodDetails(null);
            }}
          >
            Close
          </Button>
        </ModalFooter>
      </Modal>
    </div>
  );
};

export default ScoringPeriods;
